import type { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

export type DescriptionTextProps = ComponentProps<"p">;

export function DescriptionText({
	className,
	children,
	...props
}: DescriptionTextProps) {
	if (!children) {
		return null;
	}

	return (
		<p
			className={twMerge("text-gray-500 text-sm", className)}
			data-slot="description-text"
			{...props}
		>
			{children}
		</p>
	);
}
